import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorCodes } from '../../constants/ErrorCodes';
import { RemitoService } from '../../services/remito.service';
import {HttpErrorResponse} from "@angular/common/http";
import {NotificationService} from "../../services/notification.service";
import {Printed} from "../../models/Printed";
import {Remito} from "../../models/Remito";

@Component({
  selector: 'app-generate-remitos-number',
  templateUrl: './generate-remitos-number.component.html'
})
export class GenerateRemitosNumberComponent implements OnInit {
    rmtNum: number;
    ptoEmision: string;
    impresora: string;
    errors: HttpErrorResponse[] = [];
    previousRemito: Boolean;
    isVehicle: boolean;

    constructor(@Inject(MAT_DIALOG_DATA) public  data: { remitoNum: number, ptoEmision: string, impresora: string, previousRemito: Boolean, isVehicle: boolean },
                private remitoService: RemitoService, private notificationService: NotificationService) {
    }

    ngOnInit(): void {
        this.rmtNum = this.data.remitoNum;
        this.ptoEmision = this.data.ptoEmision;
        this.impresora = this.data.impresora;
        this.previousRemito = this.data.previousRemito;
        this.isVehicle = this.data.isVehicle;
    }

    // Hide print and email button in dialog popup if type is balanza or vehicle
    isBalanzaOrVehicle(): boolean{
      return this.isVehicle || ('0036' === this.ptoEmision || '0038' === this.ptoEmision || '0009' === this.ptoEmision || '0011' === this.ptoEmision);
    }
}
